import styled from 'styled-components';

export const ProfileContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: start;
  border: 2px solid var(--color-level-2);
  border-radius: 160px;
  padding: var(--size-space-tiny) var(--size-space-medium)
    var(--size-space-tiny) var(--size-space-tiny);
  transition: all 0.25s ease;
  flex-grow: 1;
  width: 100%;
  img {
    flex-grow: 0;
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: 100%;
    transition: all 0.1s ease;
  }
  div {
    flex-grow: 1;
    flex-shrink: 1;
    text-align: left;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0 var(--size-space-small);
  }
  /*
    &:hover {border-color: var(--color-level-4);img {transform: scale(1.2);}}
   */
`;
